import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import {VerticalNavigationComponent} from "../../shared/vertical-header/vertical-navigation.component";

@Component({
  selector: 'app-blank-layout',
  standalone: true,
  imports: [RouterModule, VerticalNavigationComponent],
  templateUrl: './blank.component.html',
  styleUrls: []
})
export class BlankComponent {

}
